import { render } from "./Logos.vue?vue&type=template&id=78bc433e"
import script from "./Logos.vue?vue&type=script&lang=js"
export * from "./Logos.vue?vue&type=script&lang=js"

import "./Logos.vue?vue&type=style&index=0&id=78bc433e&lang=css"
script.render = render

export default script